import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Input,
    AfterViewInit,
    OnDestroy
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, ReplaySubject, combineLatest } from 'rxjs';
import * as fromStore from '../store';
import * as fromUser from '../../user-info/store';
import * as fromShared from '../../shared';
import { takeWhile, map } from 'rxjs/operators';
import { IUserInfo } from '../../user-info/IUserInfo';

@Component({
    selector: 'ef-checkup-feature',
    templateUrl: './checkup-feature.component.html',
    styleUrls: ['./checkup-feature.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckupFeatureComponent
    implements OnInit, AfterViewInit, OnDestroy {
    process$: Observable<fromShared.Process>;
    checkups$: Observable<Array<fromStore.Checkup>>;
    processes$: Observable<Array<fromShared.Process>>;
    userInfo$: Observable<IUserInfo>;
    private active = true;
    loadingText = 'Loading checkup...';
    constructor(private store: Store<fromStore.State>) {}

    ngOnInit() {
        this.checkups$ = this.store.pipe(select(fromStore.selectAll));
        this.processes$ = this.store.pipe(select(fromUser.getUserProcesses));
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    ngAfterViewInit(): void {
        combineLatest([this.process$, this.userInfo$])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, user]) => {
                this.store.dispatch(
                    fromStore.getCheckups({
                        ProcessID:
                            process.ProcessID === 145
                                ? null
                                : process.ProcessID,
                        EmployeeListID: user.EmployeeListID
                    })
                );
            });
    }
}
